import { combineReducers } from "@reduxjs/toolkit";
import estimatedBenefitAccountInfo from "./estimated-benefit-account-info";

const estimatedBenefitAccountInfoReducer = combineReducers({
  estimatedBenefitAccountInfo,
});

export default estimatedBenefitAccountInfoReducer;
